import React, { FunctionComponent } from 'react'
import { Circle, Defs, LinearGradient, Path, Stop, Svg } from 'react-native-svg'

/**
 * Used to present an AI Coach in messenger
 */
export const AICoachIcon: FunctionComponent<AICoachIconProps> = ({ size = 24 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 48 48' fill='none'>
      <Circle cx='24' cy='24' r='24' fill='url(#paint0_linear_3003_81126)' />
      <Path
        d='M24 34C23.4817 34 23.0518 33.5702 23.0518 33.0518C23.0518 28.6523 19.335 24.9482 14.9482 24.9482C14.4298 24.9482 14 24.5183 14 24C14 23.4817 14.4298 23.0518 14.9482 23.0518C19.3477 23.0518 23.0518 19.335 23.0518 14.9482C23.0518 14.4298 23.4817 14 24 14C24.5183 14 24.9482 14.4298 24.9482 14.9482C24.9482 19.3477 28.665 23.0518 33.0518 23.0518C33.5702 23.0518 34 23.4817 34 24C34 24.5183 33.5702 24.9482 33.0518 24.9482C28.6523 24.9482 24.9482 28.665 24.9482 33.0518C24.9482 33.5702 24.5183 34 24 34Z'
        fill='url(#paint1_linear_3003_81126)'
      />
      <Path
        d='M32.5487 19.4549C32.3438 19.4549 32.1737 19.2849 32.1737 19.0799C32.1737 17.3399 30.7038 15.8749 28.9688 15.8749C28.7638 15.8749 28.5938 15.7049 28.5938 15.4999C28.5938 15.2949 28.7638 15.1249 28.9688 15.1249C30.7088 15.1249 32.1737 13.6549 32.1737 11.9199C32.1737 11.7149 32.3438 11.5449 32.5487 11.5449C32.7537 11.5449 32.9237 11.7149 32.9237 11.9199C32.9237 13.6599 34.3937 15.1249 36.1287 15.1249C36.3337 15.1249 36.5037 15.2949 36.5037 15.4999C36.5037 15.7049 36.3337 15.8749 36.1287 15.8749C34.3888 15.8749 32.9237 17.3449 32.9237 19.0799C32.9237 19.2849 32.7537 19.4549 32.5487 19.4549Z'
        fill='url(#paint2_linear_3003_81126)'
      />
      <Defs>
        <LinearGradient
          id='paint0_linear_3003_81126'
          x1='22.8256'
          y1='0.750816'
          x2='22.8256'
          y2='48.6801'
          gradientUnits='userSpaceOnUse'
        >
          <Stop stopColor='#E7F8F8' />
          <Stop offset='1' stopColor='#F3F5FF' />
        </LinearGradient>
        <LinearGradient
          id='paint1_linear_3003_81126'
          x1='32.6286'
          y1='-14.2353'
          x2='2.19705'
          y2='-8.10317'
          gradientUnits='userSpaceOnUse'
        >
          <Stop offset='0.16' stopColor='#43A484' />
          <Stop offset='0.545' stopColor='#06A0BA' />
          <Stop offset='0.88' stopColor='#5F76C4' />
        </LinearGradient>
        <LinearGradient
          id='paint2_linear_3003_81126'
          x1='35.9614'
          y1='0.377862'
          x2='23.9257'
          y2='2.80312'
          gradientUnits='userSpaceOnUse'
        >
          <Stop offset='0.16' stopColor='#43A484' />
          <Stop offset='0.545' stopColor='#06A0BA' />
          <Stop offset='0.88' stopColor='#5F76C4' />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export type AICoachIconProps = {
  size?: string | number
}
